module.exports = __webpack_public_path__ + "img/Icon1.74007f92.svg";